import { renderLastPlaceholder } from '../../render-utils';
import type { DnDProps } from './types';
import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';

interface GetOnDragEnterProps {
  reactFlowInstance: DnDProps['reactFlowInstance'],
  setElementsSelectable: (value: boolean) => void
}

export const getOnDragEnter = ({ reactFlowInstance, setElementsSelectable }: GetOnDragEnterProps) => () => {
  const nodes = reactFlowInstance?.getNodes() as CustomNode[];
  const edges = reactFlowInstance?.getEdges() as CustomEdge[];
  const setNodes = reactFlowInstance?.setNodes;
  const newNodes = renderLastPlaceholder(nodes, edges, { visible: true });

  setTimeout(() => {
    setNodes?.(newNodes);
    setElementsSelectable(false);
  }, 0)
};
